import { REG_EXP } from "@/config/const.js";
import { DATE_FORMAT } from "@/config/date.js";

export default {
    methods: {
        checkEmail() {
            let pass = false;
            const target = "email";

            if (this.userInfo[target].trim() === "") {
                $(`#${target}`).addClass("is-invalid");
                this.errMsg[target] = "이메일을 입력해주세요";
            } else if (!REG_EXP.EMAIL.test(this.userInfo[target])) {
                $(`#${target}`).addClass("is-invalid");
                this.errMsg[target] = "올바른 이메일 주소를 입력해주세요";
            } else {
                pass = true;
                $(`#${target}`).removeClass("is-invalid");
            }

            return pass;
        },
        targetCheckPw(target) {
            let pass = false;

            if (target.model.trim() === "") {
                $(`#${target.id}`).addClass("is-invalid");
                this.errMsg[target.id] = "비밀번호를 입력해주세요";
            } else if (!REG_EXP.PASSWORD.test(target.model)) {
                $(`#${target.id}`).addClass("is-invalid");
                this.errMsg[target.id] = "8~16자 영문, 숫자, 특수문자 조합을 입력해주세요";
            } else {
                pass = true;
                $(`#${target.id}`).removeClass("is-invalid");
            }

            return pass;
        },
        checkPw() {
            let pass = false;
            const target = "password";

            if (this.userInfo[target].trim() === "") {
                $(`#${target}`).addClass("is-invalid");
                this.errMsg[target] = "비밀번호를 입력해주세요";
            } else if (!REG_EXP.PASSWORD.test(this.userInfo[target])) {
                $(`#${target}`).addClass("is-invalid");
                this.errMsg[target] = "8~16자 영문, 숫자, 특수문자 조합을 입력해주세요";
            } else {
                pass = true;
                $(`#${target}`).removeClass("is-invalid");
            }

            return pass;
        },
        checkPwConfirm() {
            let pass = false;
            const target = "password_confirm";

            if (this[target].trim() === "") {
                $(`#${target}`).addClass("is-invalid");
                this.errMsg[target] = "비밀번호를 입력해주세요";
            } else if (!REG_EXP.PASSWORD.test(this[target])) {
                $(`#${target}`).addClass("is-invalid");
                this.errMsg[target] = "8~16자 영문, 숫자, 특수문자 조합을 입력해주세요";
            } else if (this.userInfo.password !== this[target]) {
                $(`#${target}`).addClass("is-invalid");
                this.errMsg[target] = "비밀번호가 일치하지 않습니다";
            } else {
                pass = true;
                $(`#${target}`).removeClass("is-invalid");
            }

            return pass;
        },
        checkName() {
            let pass = false;
            const target = "name";

            if (this.userInfo[target].trim() === "") {
                $(`#${target}`).addClass("is-invalid");
                this.errMsg[target] = "원장님 성함을 입력해주세요";
            } else {
                pass = true;
                $(`#${target}`).removeClass("is-invalid");
            }

            return pass;
        },
        checkPhoneNo() {
            let pass = false;
            const target = "phone_no";

            if (this.userInfo[target].trim() === "") {
                $(`#${target}`).addClass("is-invalid");
                this.errMsg[target] = "휴대폰 번호를 입력해주세요";
            } else if (!REG_EXP.PHONE.test(this.userInfo[target])) {
                $(`#${target}`).addClass("is-invalid");
                this.errMsg[target] = "올바른 휴대폰 번호를 입력해주세요";
            } else {
                pass = true;
                $(`#${target}`).removeClass("is-invalid");
            }

            return pass;
        },
        checkVerifyNumber() {
            let pass = false;
            const target = "verify_number";

            if (this[target].trim() === "" || this[target].length < 4) {
                $(`#${target}`).addClass("is-invalid");
                this.errMsg[target] = "인증번호 4자리를 입력해주세요";
            } else {
                pass = true;
                $(`#${target}`).removeClass("is-invalid");
            }

            return pass;
        },
        sendVerifyNumber(isSave) {
            if (this.checkPhoneNo()) {

                this.axios.get(`/sendSms/${this.userInfo.phone_no}/signUp`).then(res => {
                    if (isSave) {
                        this.receive.phone_no = this.userInfo.phone_no;
                        this.receive.verify_number = res.data.result;
                    }
                    alert("인증번호가 4자리가 발송되었습니다.");
                }).catch(error => {
                    console.log(error);
                    alert("휴대폰 인증 중에 오류가 발생하였습니다.\n다시 시도해주세요.");
                });

                // const min = 1000;
                // const max = 10000;
                // const verifyNumber = Math.floor(Math.random() * (max - min)) + min;

                // if (isSave) {
                //     this.receive.phone_no = this.userInfo.phone_no;
                //     this.receive.verify_number = verifyNumber.toString();
                // }

                // if (this.isVeryfied) {
                //     this.isVeryfied = false;
                // }

                // alert(`인증번호 4자리가 발송되었습니다.\n${verifyNumber}`);
            }
        },

        /** 
         * * confirmVerifyNumber() -> 휴대폰 번호 인증 절차 확인하는 함수
         * @param isNotify (True || False) 값이 넘어올 경우 인증 검사 후 alert 노출 여부
         * @param getKosiwon (True || False) 값이 넘어올 경우 kosiwon을 가져오는 작업 (회원 가입 시 사용)
         * */
        confirmVerifyNumber(isNotify, getKosiwon) {
            if (this.verify_number !== this.receive.verify_number) {
                alert("인증번호가 일치하지 않습니다.\n다시 시도해주세요");
                return false;
            }

            if (this.userInfo.phone_no !== this.receive.phone_no) {
                this.isVeryfied = false;
                alert("휴대폰 번호가 변경되었습니다.\n인증을 다시 진행해주세요");
                return false;
            }

            if (isNotify) {
                if (getKosiwon) {
                    this.axios.post("/registerKosiwonList", {
                        phone_no: this.userInfo.phone_no
                    }).then(res => {
                        this.isVeryfied = true;
                        this.kosiwonList = res.data.result.map(item => {
                            return {
                                ...item,
                                created: DATE_FORMAT(item.created),
                                is_save: true
                            }
                        });
                    }).catch(error => {
                        console.log(error);
                        alert("휴대폰 인증 중에 오류가 발생하였습니다.\n다시 시도해주세요.");
                    });
                } else {
                    this.isVeryfied = true;
                }
                alert("인증이 완료되었습니다.");
                return;
            } else {
                // ? this.isVeryfied 인증이 되지 않은 경우에 alert 노출.
                if (this.isVeryfied !== undefined && !this.isVeryfied) {
                    alert("휴대폰 인증을 진행해주세요");
                    return false;
                } else {
                    return true;
                }
            }
        }
    }
}
